<nav class="text-center mr-auto ml-auto px-4 mb-3">
  <div class="row justify-content-center align-items-center">
    <button type="menu" class="btn col-2 flex-fill shadow-none" [ngClass]="{'opacity-0': searchIsActive }" (click)="menuIsActive = !menuIsActive">
      <i class="fas fa-bars menu-icon" [ngClass]="{'fa-bars': !menuIsActive, 'fa-times': menuIsActive }"></i>
    </button>
    <div class="col-8 flex-fill">
      <h1 class="mb-1 h1 my-5 logo-font"><a routerLink="/">Bordvers.dk</a></h1>
    </div>
    <button type="search" class="btn col-2 flex-fill shadow-none" [ngClass]="{'opacity-0': menuIsActive }" (click)="onClickToggleSearch(searchField)">
      <i class="fas fa-search menu-icon" [ngClass]="{'fa-search': !searchIsActive, 'fa-times': searchIsActive}"></i>
    </button>
  </div>

  <div class="px-5 search global-search" [ngClass]="{'active': searchIsActive}">
    <div class="content">
      <input type="search" class="mt-0 form-control search-field shadow-none mb-3" #searchField placeholder="Søg efter bordvers" (keyup)="onChangeSearch($event)" (clear)="onChangeSearch($event)">
      <div class="text-left" *ngIf="searchResults.length > 0">
        <a *ngFor="let result of searchResults" [routerLink]="['/vers/', result.handle]" class="border-bottom p-2 d-block" (click)="searchIsActive = false">
          {{result.title}}
        </a>
      </div>
    </div>
  </div>

  <div class="menu text-left px-5 pb-5" [ngClass]="{'active': menuIsActive}">
    <div class="content">
      <div class="list-group mb-5">
        <a routerLink="/" class="list-group-item list-group-item-action">
          <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1">Dagens bordvers</h5>
          </div>
          <small>Vis dagens aktuelle bordvers</small>
        </a>
        <a routerLink="/alle-vers" class="list-group-item list-group-item-action">
          <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1">Alle bordvers</h5>
          </div>
          <small>Vis en oversigt over alle bordvers</small>
        </a>
      </div>

      <div class="list-group mb-5">
        <a routerLink="/om-bordvers.dk" class="list-group-item list-group-item-action">
          <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1">Om bordvers.dk</h5>
          </div>
          <small>Læs mere om bordvers.dk</small>
        </a>
        <a routerLink="/om-bordvers.dk/cookie-og-privatlivspolitik" class="list-group-item list-group-item-action">
          <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1">Cookie- og privatlivspolitik</h5>
          </div>
          <small>Læs mere om cookie- og privatlivspolitikken for dette websted.</small>
        </a>
      </div>
    </div>
  </div>
</nav>

<router-outlet></router-outlet>

<footer>
  <div class="row">
    <div class="col-12 col-md-2"></div>
    <div class="col-12 col-md-2"></div>
  </div>
  <small class="text-muted text-center d-block border-top py-4 font-italic">Udviklet af <a href="https://madebypomelo.com" target="_blank">madebypomelo.com</a>.</small>
</footer>